import { Component, EventEmitter, Input, Output, ViewEncapsulation, ViewChild, ElementRef, OnInit, OnChanges, AfterViewInit, afterNextRender } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TextareaFieldComponent } from '../textarea-field/textarea-field.component';
import { InputFieldComponent } from '../input-field/input-field.component';
import { SelectFieldComponent } from '../select-field/select-field.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RmsDateComponent } from '../date-field/date-field.component';

import { PromptButton, PromptOptions } from '../../../shared/interfaces/rms-interfaces'

@Component({
  selector: 'app-rms-prompt',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, TextareaFieldComponent, FormsModule, InputFieldComponent, SelectFieldComponent, RmsDateComponent],
  templateUrl: './rms-prompt.component.html',
  styleUrls: ['./rms-prompt.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RmsPromptComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild('textInput', { read: ElementRef }) textInputRef?: ElementRef<HTMLInputElement>;
  @ViewChild('textArea', { read: ElementRef }) textAreaRef?: ElementRef<HTMLTextAreaElement>;


  @Input() promptText? = '';
  @Input() htmlPrompt? = ''
  @Input() buttons: PromptButton[] = [];
  @Input() open = false;
  @Input() promptInput?: 'text' | 'textarea' | 'select' | 'checkbox' | 'radio' |'date'| null
  @Input() inputRequired: boolean = false;
  @Input() inputLabel: string = '';
  @Input() inputOptions: { [key: string]: any }[] = [];
  @Input() defaultInput: any = ''
  @Output() closed = new EventEmitter<any>();

  inputValue: any = null;
  private _resolver: ((value: any) => void) | null = null;

  /**
   * Programmatically open the prompt and await a result.
   */
  openPrompt(opts: PromptOptions): Promise<any> {
    this.promptText = opts.text ?? '';
    this.htmlPrompt = opts.htmlPrompt ?? '';
    this.buttons = (opts.buttons?.length ? opts.buttons : this.defaultYesNo());
    this.open = true;
    this.promptInput = opts.promptInput ?? null;
    this.inputRequired = opts.inputRequired ?? false;
    this.inputLabel = opts.inputLabel ?? '';
    this.inputOptions = opts.inputOptions ?? [];
    const dismissible = opts.dismissible ?? true;

    // Set up ESC/backdrop dismissal if allowed
    const escHandler = (e: KeyboardEvent) => {
      if (!dismissible) return;
      if (e.key === 'Escape') this.close(null);
    };
    window.addEventListener('keydown', escHandler, { once: true });

    return new Promise<any>((resolve) => {
      this._resolver = (val: any) => {
        window.removeEventListener('keydown', escHandler);
        resolve(val);
        this.closed.emit(val);
      };
    });
  }

  ngOnInit() {
    this.focusPromptInputIfPresent();
  }

  ngAfterViewInit(): void {
    // Also attempt after the first view init
    this.focusPromptInputIfPresent();
  }

  ngOnChanges(changes: any): void {
    // When `open` or `promptInput` toggles, schedule focus after DOM updates
    if (changes['open'] || changes['promptInput']) {
      queueMicrotask(() => this.focusPromptInputIfPresent());
    }
  }
  constructor() { afterNextRender(() => this.focusPromptInputIfPresent()); }

  private focusPromptInputIfPresent(): void {
    if (!this.open || !this.promptInput) return;

    // Try text input first, then textarea
    setTimeout(() => {
      const el: HTMLElement | undefined =
        this.textInputRef?.nativeElement ?? this.textAreaRef?.nativeElement;
      console.log(el)
      if (el) {
        // Prevent scroll jumps and ensure we can type immediately
        el.setAttribute('tabindex', '-1'); // improves focusability for some custom controls
        el.focus({ preventScroll: true });
        // Place caret at the end (optional)
        if ('setSelectionRange' in el) {
          const input = el as HTMLInputElement | HTMLTextAreaElement;
          const len = input.value?.length ?? 0;
          try { input.setSelectionRange(len, len); } catch { }
        }
      }

    }, 5000);
  }

  onBackdropClick() {
    // Only close if backdrop should dismiss (if caller used defaultYesNo we allow it)
    this.close(null);
  }

  onButtonClick(btn: PromptButton) {
    try { btn.action?.(); } catch { }
    if (this.promptInput) {
      this.close({ buttonValue: btn.value, inputValue: this.inputValue })
    }
    else {
      this.close(btn.value);
    }
  }

  private close(result: any) {
    this.open = false;
    this._resolver?.(result);
    this._resolver = null;
  }

  private defaultYesNo(): PromptButton[] {
    return [
      { label: 'Yes', icon: 'check', buttonClass: 'btn-yes', value: true },
      { label: 'No', icon: 'close', buttonClass: 'btn-no', value: false }
    ];
  }
  UpdateValue() {
    console.log(this.inputValue);
  }
  SetSelectValue(value: any) {
    console.log(value);
    this.inputValue = value;
  }
}
